import palette from '../palette';
import typography from '../typography';

export default {
  root: {
    display: 'flex',
    alignItems: 'center',

    fontSize: 14,
    lineHeight: '14px',
    fontWeight: 'normal',
    color: "#212529",

    '&$active': {
      color: "#212529",
    }
  }
};
